import { render } from "./WorkflowBacklog.vue?vue&type=template&id=20bcd186&scoped=true"
import script from "./WorkflowBacklog.vue?vue&type=script&lang=js"
export * from "./WorkflowBacklog.vue?vue&type=script&lang=js"

import "./WorkflowBacklog.vue?vue&type=style&index=0&id=20bcd186&scoped=true&lang=css"
import "./WorkflowBacklog.vue?vue&type=style&index=1&id=20bcd186&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20bcd186"]])

export default __exports__